var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.items || 15),function(item){return _c('div',{key:item,staticClass:"skeleton-card"},[_c('div',{staticClass:"my-10"},[_c('b-skeleton',{attrs:{"height":"1.2rem","width":"80%","animated":_vm.animated}})],1),_c('div',[_c('b-skeleton',{attrs:{"height":"1.2rem","width":"40%","animated":_vm.animated}})],1)])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }